import React from "react";
import { Star, StarHalf } from "lucide-react";

export default function StarRating({ rating = 0, count = 0, size = 12, testId = "star-rating" }) {
  const full = Math.floor(rating);
  const hasHalf = rating - full >= 0.25 && rating - full < 0.75;
  const totalFull = hasHalf ? full : Math.round(rating);
  const stars = Array.from({ length: 5 });
  return (
    <div className="inline-flex items-center gap-1" data-testid={testId}>
      {stars.map((_, i) => {
        const filled = i < totalFull;
        const half = hasHalf && i === full;
        return half ? (
          <StarHalf key={i} size={size} className="text-[#e63946] fill-[#e63946]" />
        ) : (
          <Star
            key={i}
            size={size}
            className={filled ? "text-[#e63946] fill-[#e63946]" : "text-zinc-600"}
          />
        );
      })}
      {count > 0 && (
        <span className="ml-1 text-[11px] text-zinc-400 font-mono">
          {rating.toFixed(1)} · {count}
        </span>
      )}
    </div>
  );
}
